<template>
    <div class="exchange-list-area">
        <div class="header container">
            <img class="container-bg" :src="prizeOptions.header && prizeOptions.header.img.url" alt />
        </div>
        <template v-if="!exchangeList.length">
            <div class="center container">
                <img class="container-bg" :src="prizeOptions.center && prizeOptions.center.img.url"  alt />
            </div>
        </template>
        <template v-else>
            <template v-if="showList">
                <div class="container" :key="index" v-for="(item, index) in exchangeList">
                    <img class="container-bg"  :src="item.prizeImg" v-debounce:viewRecord.prevent="item" alt />
                </div>
            </template>
        </template>
        <div class="footer container">
            <img class="container-bg" :src="prizeOptions.footer && prizeOptions.footer.img.url" alt />
        </div>
    </div>
</template>

<script>

export default {

    name: 'ExchangeListArea',

    props: {

        info: { // 组件配置项
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

        pageDetail: { // 活动数据
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },
    },

    watch: {
        pageDetail: {
            handler(val) {
                if (val) {
                    this.showList = false
                    this.$nextTick(() => {
                        this.initList()
                    })
                }
            },
            deep: true
        },

    },

    data() {
        return {

            showList: false, // 是否展示列表
            prizeOptions: {}, // 奖品配置项
            exchangeList: [], // 

        }
    },

    mounted() {
        this.initList()
        this.formatData()

    },

    methods: {

        initList() {
            this.exchangeList = this.pageDetail.exchangeList || []
            this.showList = true
        },

        formatData() {
            this.prizeOptions = this.info.baseConfig || {}
        },

        viewRecord(e) {
            let { prizeType, status, canFill } = e
            if (prizeType) {
                switch (prizeType) {
                    case 1: // 虚拟奖品展示所用的数据直接就在列表里 上升到公共父组件 触发展示操作
                        this.$emit('emitEvent', {
                            type: 'viewVirtualEvent',
                            data: e,
                            options: null
                        })
                        break;
                    case 2: // 实物奖品的展示在子组件里分发不同的事件  1->可填写物流信息 未填写, 2->可填写物流信息 已填写, 3->不可填写物流信息 未填写, 4->不可填写物流信息 已填写
                        if (canFill) { // 可以填写物流信息
                            if (!status) { // 0 未填写物流
                                this.$emit('emitEvent', {
                                    type: 'addAddressEvent',
                                    data: e,
                                    options: null
                                })
                            } else { // 1 已填写物流
                                this.$emit('emitEvent', {
                                    type: 'editAddressEvent',
                                    data: e,
                                    options: null
                                })
                            }
                        } else {
                            this.toast(e.cannotFillTip)
                        }
                        break;
                    case 3: 
                        this.$emit('emitEvent', {
                            type: 'viewNoticeEvent',
                            data: e,
                            options: null
                        })
                        break;
                }
            }
            
        },

        toast(txt, duration) { // 封装统一的信息处理函数
            this.$toast({
                styles: {
                    maskColor: "rgba(0,0,0,0)",
                    background: "rgba(0,0,0,0.4)",
                    messageColor: "#fff"
                },
                content: txt,
                duration: duration || 2000
            })
        },


    },

}
</script>

<style lang="scss" scoped>
.exchange-list-area {
    width: 100%;
    position: relative;
}
.container {
    width: 100%;
    .container-bg {
        width: 100%;
    }
}
</style>